import { ReferenceLinkContent } from '../../models/app-data-model';

export type BackgroundStyle = {
  backgroundColor?: string;
  backgroundImage?: string;
};

/**
 * This hook is meant to generate the background style for components that display a solid color or gradient background
 * based on background style/color data from ContentStack
 * i.e: some hero and CTA components
 *
 * @param backgroundStyleData (as a ReferenceLinkContent array)
 * @returns The background style object containing either a solid color or a linear gradient
 */
function useBackgroundStyle(backgroundStyleData: ReferenceLinkContent[]): BackgroundStyle {
  let backgroundStyle = {} as BackgroundStyle;

  if (backgroundStyleData.find((el) => el.gradient)) {
    const bgGradient = backgroundStyleData.find((el) => el.gradient)?.gradient;
    backgroundStyle = { backgroundImage: `linear-gradient(135deg, ${bgGradient?.start_color}, ${bgGradient?.end_color})` };
  } else if (backgroundStyleData.find((el) => el.color)) {
    backgroundStyle = { backgroundColor: backgroundStyleData.find((el) => el.color)?.color?.color };
  }

  return backgroundStyle;
}

export default useBackgroundStyle;
